import React from "react";
import InputSlider from "../../shared/controls/input-slider";
import NumberFormat from "react-number-format";
import CurrencyInputContainer from "../../shared/currency-input-container";
import { Link } from "react-router-dom";
import CurrencyDisplay from "../../shared/currency-display";

function MiscellaneousItem(setDressings) {
  const {
    item,
    onChangeItemBuget,
    onChangeItemName,
    onChangeItemDays,
    maxDays,
    hasShootingDays,
    readOnly,
    saving
  } = setDressings;

  return (
    <tr>
      <td> <input
        className="input"
        type="text"
        value={item.name}
        onChange={(e) => onChangeItemName(item.id, e.target.value)}
        disabled={readOnly}
      /> </td>
      <td className="budget-days-column">
        {item.hire ? (

          <InputSlider
            step={1}
            formatLabel={(value) => `${value}`}
            draggableTrack={false}
            allowSameValues={false}
            maxValue={maxDays}
            minValue={1}
            trackColor="#162135"
            value={item.days}
            onChange={(val) => onChangeItemDays(item.id, val)}
            disabled={readOnly || saving}
          />

        ) : (
          "-"
        )}
      </td>
      <td className="budget-daily-rate-column">
        <CurrencyInputContainer
          value={
            item.hire ? item.dailyBudget : item.budget
          }
          onChange={(val) => onChangeItemBuget(item.id, val)}
          readOnly={readOnly}
          disabled={saving}
        />
      </td>
      {/* <td>{item.quantity}</td> */}
      <td className="has-text-right">
        <CurrencyDisplay
          value={item.total}
        />
      </td>
    </tr>
  );
}

export default MiscellaneousItem;
